import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox } from '@/_components';
import type { TeamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';
import { nameResolver } from '@/_shared';

import { useGetTeamMembersMutation } from '../apis';

type FormTeamMembersAsyncMultiSelectProps = FormAsyncComboboxProps<TeamMemberQueryLinkerSchema, true>;

export function TeamMembersAsyncMultiSelect(props: FormTeamMembersAsyncMultiSelectProps) {
  const itemToString = useCallback((item?: TeamMemberQueryLinkerSchema | null): ReactNode => {
    if (!item) {
      return '';
    }
    return nameResolver(item.first_name, item.last_name);
  }, []);

  const keyExtractor = useCallback((item?: TeamMemberQueryLinkerSchema | null) => item?.id?.toString() ?? '', []);

  return (
    <FormAsyncCombobox
      {...props}
      isMulti
      itemToString={itemToString}
      keyExtractor={keyExtractor}
      useApi={useGetTeamMembersMutation}
      menuPortalTarget={null}
    />
  );
}
